import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const FormList = () => {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [examCenter, setExamCenter] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 4; // 👈 change as needed

    useEffect(() => {
        setCurrentPage(1);   // reset page on filter
        fetchForms();
    }, [examCenter]);


    const fetchForms = () => {
        setLoading(true);
        let url = 'https://dirasa.in/api/admin/forms.php';
        if (examCenter) {
            url += '?exam_center=' + encodeURIComponent(examCenter);
        }

        fetch(url)
            .then(res => res.json())
            .then(json => {
                setForms(json.data || []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };
    const totalItems = forms.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const paginatedForms = forms.slice(startIndex, endIndex);
    const renderPagination = () => {
    if (totalPages <= 1) return null;

    return (
        <div style={pagination}>
            <button
                style={pageBtn}
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}
            >
                Prev
            </button>

            {[...Array(totalPages)].map((_, i) => (
                <button
                    key={i}
                    style={{
                        ...pageBtn,
                        background: currentPage === i + 1 ? '#c31a1a' : '#fff',
                        color: currentPage === i + 1 ? '#fff' : '#333'
                    }}
                    onClick={() => setCurrentPage(i + 1)}
                >
                    {i + 1}
                </button>
            ))}

            <button
                style={pageBtn}
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(p => p + 1)}
            >
                Next
            </button>
        </div>
    );
};

    return (
        <div>
            <h3>Application Forms</h3>

            {/* FILTER */}
            <select
                value={examCenter}
                onChange={e => setExamCenter(e.target.value)}
                style={selectStyle}
            >
                <option value="">All Exam Centers</option>
                                    <option value="Itahar High School (H.S), Itahar, Uttar Dinajpur (Date: 15/02/26, Time: 12 PM)">
                            Itahar High School (H.S) – 15 Feb, 12 PM
                        </option>

                        <option value="Rashakhowa High School (H.S), Rashakhowa, Uttar Dinajpur (Date: 16/02/26, Time: 1 PM)">
                            Rashakhowa High School – 16 Feb, 1 PM
                        </option>

                        <option value="Kumarganj High School (H.S), Kumarganj, Malda (Date: 17/02/26, Time: 1 PM)">
                            Kumarganj High School – 17 Feb, 1 PM
                        </option>

                        <option value="OSD English School, Samsi Bypass, Malda (Date: 21/02/26, Time: 1 PM)">
                            OSD English School – 21 Feb, 1 PM
                        </option>

                        <option value="Narayanpur High School (H.S), Narayanpur, Dakshin Dinajpur (Date: 22/02/26, Time: 1 PM)">
                            Narayanpur High School – 22 Feb, 1 PM
                        </option>

                        <option value="Dirasa Boys Unit, Gabgachi Jadavpur, Malda (Date: 24/02/26, Time: 1 PM)">
                            Dirasa Boys Unit – 24 Feb, 1 PM
                        </option>
            </select>
            <div style={counterStyle}>
                Showing {startIndex + 1} – {Math.min(endIndex, totalItems)} of {totalItems} forms
            </div>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    {/* DESKTOP TABLE */}
                    <div className="desktop-only">
                        <table style={table}>
                            <thead>
                                <tr>
                                    <th style={th}>Photo</th>
                                    <th style={th}>Form ID</th>
                                    <th style={th}>Name</th>
                                    <th style={th}>Contact</th>
                                    <th style={th}>Exam Center</th>
                                    <th style={th}>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {paginatedForms.map(f => (
                                    <tr key={f.form_id}>
                                        <td style={td}>
                                            <img src={f.student_photo_url} alt="" style={photo} />
                                        </td>
                                        <td style={td}>{f.form_id}</td>
                                        <td style={td}>{f.name}</td>
                                        <td style={td}>{f.contact}</td>
                                        <td style={td}>{f.exam_center}</td>
                                        <td style={td}>
                                            <Link to={`/admin/forms/${f.form_id}`} style={viewBtn}>
                                                View
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                                
                                    {renderPagination()}
   
                    </div>
                                
                    {/* MOBILE CARDS */}
                    <div className="mobile-only">
                        {paginatedForms.map(f => (
                            <div key={f.form_id} style={card}>
                                <div style={cardRow}>
                                    {/* LEFT INFO */}
                                    <div style={cardInfo}>
                                        <div style={{ fontWeight: 600 }}>{f.name}</div>
                                        <div style={infoText}>Form ID: {f.form_id}</div>
                                        <div style={infoText}>Contact: {f.contact}</div>
                                        <div style={infoText}>Center: {f.exam_center}</div>
                                    </div>

                                    {/* RIGHT IMAGE */}
                                    <div style={cardImageBox}>
                                        <img
                                            src={f.student_photo_url}
                                            alt=""
                                            style={photoRight}
                                        />
                                    </div>
                                </div>

                                <Link
                                    to={`/admin/forms/${f.form_id}`}
                                    style={viewBtnBlock}
                                >
                                    View Form
                                </Link>
                            </div>
                        ))}
                        {renderPagination()}
                    </div>
                </>
            )}
        </div>
    );
};

export default FormList;


/* ================= STYLES ================= */

const selectStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '15px'
};

const table = {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    background: '#fff',
    border: '1px solid #ddd'
};


const photo = {
    width: '60px',          // ✅ width < height
    height: '70px',
    objectFit: 'cover',
    borderRadius: '4px',
    border: '1px solid #c31a1a', // ✅ red border
    background: '#fff'
};


const card = {
    background: '#fff',
    padding: '15px',
    marginBottom: '15px',
    borderRadius: '6px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
};

const cardRow = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px'
};

const cardInfo = {
    flex: 1,
    fontSize: '13px'
};

const infoText = {
    marginTop: '4px'
};

const cardImageBox = {
    width: '90px',
    flexShrink: 0
};

const photoRight = {
    width: '90px',
    height: '90px',
    objectFit: 'cover',
    borderRadius: '6px'
};

const viewBtn = {
    background: '#c31a1a',
    color: '#fff',
    padding: '6px 12px',
    borderRadius: '4px',
    textDecoration: 'none'
};

const viewBtnBlock = {
    background: '#c31a1a',
    color: '#fff',
    padding: '10px',
    borderRadius: '4px',
    textDecoration: 'none',
    display: 'block',
    textAlign: 'center',
    marginTop: '12px'
};
const th = {
    background: '#c31a1a',
    color: '#fff',
    textAlign: 'left',
    padding: '12px',
    fontWeight: '600',
    borderRight: '1px solid #ffffff55', // ✅ column line
    borderBottom: '2px solid #b01818'
};

const td = {
    background: '#ffffff',
    padding: '10px',
    borderRight: '1px solid #e0e0e0',   // ✅ column line
    borderBottom: '1px solid #eee',
    verticalAlign: 'middle',
    color: '#333'
};

const counterStyle = {
    marginBottom: '10px',
    fontSize: '14px',
    color: '#555'
};

const pagination = {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    marginTop: '20px',
    flexWrap: 'wrap'
};

const pageBtn = {
    padding: '6px 12px',
    border: '1px solid #c31a1a',
    background: '#fff',
    color: '#333',
    cursor: 'pointer',
    borderRadius: '4px'
};
